<template>
  <div class="overlay">
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ t("HELP") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="ps-3 my-2">
              <h6>{{ t("ECOMMERCE_HELP.WHAT_IS_PAYJOY") }}</h6>
              <p>
                {{ t("ECOMMERCE_HELP.PAYJOY_IS") }}
              </p>
            </div>
            <div class="ps-3 my-2">
              <div class="d-inline-block align-top pt-3">
                <img
                  :src="`${useAsset(
                    'img/merchant-console/phone_call_gray.svg'
                  )}`"
                  alt="help icon"
                />
              </div>
              <div class="d-inline-block ms-2 px-3 my-2">
                <h6 v-html="t('ECOMMERCE_HELP.CALL_US')"></h6>
                <p>{{ t("ECOMMERCE_HELP.FROM_TO") }}</p>
              </div>
            </div>
            <div class="ps-3 my-2" v-if="showChatbot()">
              <div class="d-inline-block align-top pt-3">
                <img
                  :src="`${useAsset('img/merchant-console/chatbox_gray.svg')}`"
                  alt="help icon"
                />
              </div>
              <div
                class="d-inline-block ms-2 px-3 my-2"
                v-on:click="openChatbot"
                style="cursor: pointer"
              >
                <h6>{{ t("ECOMMERCE_HELP.CHATBOT") }}</h6>
                <p>{{ t("ECOMMERCE_HELP.ANSWER_24") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import Smooch from "smooch";
import { MerchantCountry } from "@/types/merchant";

const { t } = useI18n();

const emit = defineEmits(["close"]);

const closeModal = () => {
  emit("close");
};
const openChatbot = () => {
  Smooch.open();
};

const showChatbot = () => {
  return !MerchantCountry.CO;
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(151, 151, 151, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  z-index: 2;
}

.modal {
  display: block;
}

.modal-header .close {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
}

.modal-header .close span {
  font-size: 1.5rem;
}

.modal-title {
  font-size: 16px;
}

.modal-body {
  text-align: left;
  display: flex;
  flex-direction: column;
}

.modal-footer {
  border-top: none;
}

.modal-data {
  display: flex;
  align-items: center;
  height: 47px;
  margin-bottom: 10px;
}

.modal-data-key {
  width: 80px;
}

.modal-data-value {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  width: 410px;
  height: 40px;
  background-color: $pj-color-lighter-gray;
  border-radius: 10px;
  text-align: center;
}

.pj-green-btn {
  text-align: center;
  margin-top: 5px;
  width: calc(100% - 1rem);
  margin-left: auto;
  margin-right: auto;
}

p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
